import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, ControlLabel } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';

import { sortNutrient } from '../../util/util';

import 'react-bootstrap-typeahead/css/Typeahead.css';

/**
 * Concerns of this component:
 *   provide an autocomplete form to select a component
**/
class NutrientSelect extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(selectedComponents) {
    // receives an array of the selected options.
    const newCodes = selectedComponents.map(component => component.code);
    this.props.setNutrientCode(newCodes);
  }

  render() {
    const { components, selected, label, placeholder, multiple, emptyLabel } = this.props;

    const selectedComponents = selected.map(
      code => components.find(component => component.code === code)
    );

    return (
      <FormGroup>
        <ControlLabel>{label}</ControlLabel>
        <Typeahead
          options={components.sort(sortNutrient)}
          labelKey='display_name'
          selected={selectedComponents}
          multiple={multiple}
          maxResults={300 /* show all(218) nutrients by default and not paginate */}
          onChange={this.handleChange}
          placeholder={placeholder || 'e.g. vitamin C'}
          emptyLabel={emptyLabel || 'No matches found.'}
          minLength="1"
          submitFormOnEnter
          clearButton

        />
      </FormGroup>
    );
  }
}

NutrientSelect.propTypes = {
  components: PropTypes.array.isRequired,
  selected: PropTypes.array.isRequired,  // array of codes
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  multiple: PropTypes.bool,
  emptyLabel: PropTypes.string,
  setNutrientCode: PropTypes.func.isRequired,
};

export default NutrientSelect;



// WEBPACK FOOTER //
// ./src/components/search/common/NutrientSelect.js